<template>
  <div id="BlogHome" class="bg-yellow pb-1">
    <transition enter-active-class="animated fadeIn faster">
      <router-view/>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'Blog.Home',
  components: {},
  created() {},
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">
$animationDuration: 0.2s;
/*@import "~vue2-animate/src/sass/vue2-animate.scss";*/
@import "~animate.css/animate.css";

body {
  min-height: 100vh;
  overflow-x: hidden;
}

//#Dashboard {
//  font-family: 'Work Sans', 'Avenir', Helvetica, Arial, sans-serif;
//  -webkit-font-smoothing: antialiased;
//  -moz-osx-font-smoothing: grayscale;
//  color: #2c3e50;
//}

/*#nav {*/
/*  padding: 30px;*/

/*  a {*/
/*    font-weight: bold;*/
/*    color: #2c3e50;*/

/*    &.router-link-exact-active {*/
/*      color: #42b983;*/
/*    }*/
/*  }*/
/*}*/

.home {
  overflow: hidden;
}

:focus {
  box-shadow: none !important;
  outline: none !important;
}

.page-content {
  margin: 0 auto;
  //width: calc(100% - 13rem);
  //margin-left: 13rem;
  /*transition: all 0.4s;*/
}

.page-content-mini {
  margin: 0 auto;
  //width: calc(100% - 70px);
  //margin-left: 70px;
}

@media (max-width: 1024px) {
  /*.page-content {*/
  /*  width: calc(100% - 70px);*/
  /*  margin-left: 70px;*/
  /*  !*transition: all 0.4s;*!*/
  /*}*/
}

</style>
